import React, { useEffect, useState } from 'react';

//import { useParams } from 'react-router-dom';
import { addDocumentToItem } from './ItemService';
import { getAllDocuments } from '../Documents/DocumentService';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import appProgrammeList from './AppProgrammeList'
//import listItemChildren from './ItemChildrenList';

// const AttachChildren = ({ listItemChildren, parentId, sectionId }) => {
const AttachItemDocument = ({ listItemDocuments, itemId }) => {
  const [open, setOpen] = useState(false);
  const [documents, setDocuments] = useState<any[]>([]);
  // const navigate = useNavigate();

  // const [name, setName] = useState('');
  // const [description, setDescription] = useState('');
  // const [contactPerson, setContactPerson] = useState('');
  // const [location, setLocation] = useState('');
  // const [status, setStatus] = useState('');

  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const handleChange = (documentId) => {
    setSelectedDocumentId(documentId);
  };

  const handleClickOpen = () => {
    listItemDocuments();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listDocuments();
  }, [itemId]);

  function listDocuments() {
    getAllDocuments()
      .then((response) => {
        setDocuments(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function attachSelectedDocument(itemId, documentId) {
    //const document = {name, description, contactPerson, location, status};

    addDocumentToItem(itemId, documentId)
      .then(() => {
        // appProgrammeList();
        listItemDocuments();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select Document</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedDocumentId || ''} // Use selectedItemId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select User" id="demo-dialog-native" />
                }
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                  Select Item
                </option>
                {/* Map over items to generate options */}
                {documents.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={addProgrammeAssignment(progid, selectedProgrammeId)}>Add</Button> */}
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button
            onClick={() => attachSelectedDocument(itemId, selectedDocumentId)}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachItemDocument;
